import {Modal, Tooltip, Offcanvas} from 'bootstrap';

// ####################################################
// LOADER overlay 100%
// ####################################################
// Note: pas de gestion appels multiples
export function Loader() {
    this.loader = document.getElementById('overlay');
    if(!this.loader) throw 'dom_utils.Loader():ERROR: Veuillez insérer #loader dans le DOM';
};
Loader.prototype.show = function() {
    this.loader.style.display = 'block';
    return this;
};
Loader.prototype.hide = function() {
    this.loader.style.display = 'none';
    return this;
};

// ####################################################
// Popup (basé sur bootstrap Modal)
// ####################################################
export function Popup(id, options) {
    // @params{object}	    // fade (affichage d'en haut), btn_x (bouton croix fermeture), html_{header,body,footer}, size (xl, lg, md (default), sm)
    // backdrop = true = default |false|"static" (false || "static", pas de fermeture par clic body, "static" petit effet)
    // Attention, si utilisation fade et showMessage() appelé (un message en haut visible), petit effet visuel gênant à la fermeture popup

    // Défauts
    if(typeof options.backdrop === 'undefined') options.backdrop = true;
    if(typeof options.fade === 'undefined') options.fade = true;
    if(typeof options.btn_x === 'undefined') options.btn_x = true;

    this.d = {};
    this.options = options;
    this.el = createNode(this.getInitialHtml(id));
    this.el.querySelectorAll('form.needs-validation').forEach(form => {
	addFormValidation(form);
    });
    const modals = document.getElementById('popups');
    if(modals === null) throw 'dom_utils.Popup():ERROR: Veuillez insérer #modals dans le DOM';
    modals.appendChild(this.el);
    this.modal = new Modal(this.el, {
	// "backdrop"{default true, false, "static"}, "focus"{default true}, "keyboard"{default true = ESC ferme popup}
	backdrop: options.backdrop
    });
};

// STATIC
Popup.ids = {};
Popup.btn_x = '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>';

// Réutiliser le modal si existe déjà
Popup.get = function(id, options) {
    if(!Popup.ids[id]) {
	Popup.ids[id] = new Popup(id, options);
    }
    return Popup.ids[id];
};

// MÉTHODES
// Appel uniquement à l'init, 1 seule fois
Popup.prototype.getInitialHtml = function(id) {
    const className = `modal${this.options.fade ? ' fade' : ''}${this.options.size ? ' modal-' + this.options.size : ''}`;
    return `<div class="${className}" id="${id}" tabindex="-1">
	<div class="modal-dialog">
	    <div class="modal-content">
		<div class="modal-header">
		    ${this.options.html_header ? this.options.html_header : ''}
		    ${this.options.btn_x ? Popup.btn_x : ''}
		</div>
		<div class="modal-body">${this.options.html_body ? this.options.html_body : ''}</div>
		<div class="modal-footer">${this.options.html_footer ? this.options.html_footer : ''}</div>
	    </div>
	</div>;
    </div>`;
};

// Set HTML
Popup.prototype.setHeader = function(html) {
    if(this.options.btn_x) html += Popup.btn_x;
    this.el.querySelector('.modal-header').innerHTML = html;
};
Popup.prototype.setBody = function(html) {
    this.el.querySelector('.modal-body').innerHTML = html;
    this.el.querySelectorAll('form.needs-validation').forEach(form => {
	addFormValidation(form);
    });
    return this;
};
Popup.prototype.setFooter = function(html) {
    // Pour un bouton close: <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
    this.el.querySelector('.modal-footer').innerHTML = html;
};

// HELPERS
Popup.prototype.show = function() {
    this.modal.show();
};
Popup.prototype.hide = function() {
    this.modal.hide();
    if(typeof this.onHide === 'function') this.onHide();
};
Popup.prototype.find = function(selector) {
    return this.el.querySelector(selector);
};
Popup.prototype.findAll = function(selector) {
    return this.el.querySelectorAll(selector);
};
Popup.prototype.destroy = function() {
    this.dm.dispose();
    this.el.remove();		// Supprime les listeners
    delete Popup.ids[this.id];
};

// EVENTS (version simple, attention à ne pas les mettre en double)
Popup.prototype.setEvents = function(events) {
    // @params event{Object}	    // selector (attention, 1 seul ie: querySelector), type, listener, useCapture = false
    for(var e of events) {
	let target;
	if(e.selector === null) target = this.el;
	else if(typeof e.selector === 'string') target = this.el.querySelector(e.selector);
	else target = e.selector;
	target.addEventListener(e.type, e.listener, e.useCapture ? true : false);
    }
};

Popup.prototype.data = function(key, data) {
    // À la jQuery
    if(typeof data === 'undefined') {
	return this.d[key];
    } else {
	this.d[key] = data;
    }
};


// ####################################################
// SHOWMESSAGES (basé sur bootstrap Offcanvas)
// ####################################################
function ShowMessages() {
    this.persistent = false;
    this.el = createNode(`<div class="offcanvas offcanvas-top" tabindex="-1" id="show-messages">
	<div class="offcanvas-body">
	    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	    <div class="sm-content container-md"></div>
	</div>
    </div>`);
    document.body.append(this.el);
    this.offcanvas = new Offcanvas(this.el, {
	// "backdrop"{default true, false, "static"}, "scroll"{default false}, "keyboard"{default true = ESC ferme popup}
	backdrop: false,
	scroll: true
    });
};

// MÉTHODES (all privates)
ShowMessages.prototype.setHtml = function(html) {
    const body_el = this.el.querySelector('.sm-content');
    if(this.isVisible()) {		// Si visible, on ajoute le html à la fin
	body_el.innerHTML += (body_el.innerHTML ? '<br>' : '') + html;
    } else {				// Sinon, on remplace le contenu
	body_el.innerHTML = html;
    }
    return this;
};
ShowMessages.prototype.isVisible = function() {
    const cl = this.el.classList;
    if(cl.contains('hiding')) return false;
    if(cl.contains('show') || cl.contains('showing')) return true;
    return false;
};

// HELPERS
ShowMessages.prototype.show = function() {
    this.offcanvas.show();
};
ShowMessages.prototype.hide = function() {
    this.offcanvas.hide();
};

ShowMessages.instance = new ShowMessages();	// Instance unique
document.addEventListener('click', function(e) {
    //console.log(ShowMessages.instance.isVisible());
    var that = ShowMessages.instance;
    if(that.persistent) {	// Pas de fermeture et petit effet pour attirer l'oeil, mais 1 seule fois
	if(that.persistent !== 1) {
	    that.el.classList.add('scale-up');
	    setTimeout(() => that.el.classList.remove('scale-up'), 200);
	}
	that.persistent = 1;
    } else {
	that.hide();
    }
}, true);

export function showMessages(html = '', persistent = false) {
    // @param persistent   // si true, fermeture uniquement au clic croix, pour les messages importants
    // Éventuellement ajouter un effet à la bootstrap (un tremblement du message) si tentative de fermeture clic body
    ShowMessages.instance.persistent = persistent;
    ShowMessages.instance.setHtml(html).show();
};
export function hideMessages() {
    // Forcer le masquage d'un message
    ShowMessages.instance.hide();
};


// #######################################################
// ALERT en haut (basé sur bootstrap ALERT)
// #######################################################
export function showAlert(type, html, show = true) {
    // @param show	// true = montrer, false = masquer, "scroll" = scrollIntoView
    // Si le conteneur associé existe, on l'utilise avec un append html
    // Si n'existe pas, on le créé avec le html
    console.assert(['success', 'error'].includes(type), 'dom_utils.showAlert():ERROR: veuillez fournir un type IN("success", "error")');

    let el = document.querySelector('#alert-' + type);
    if(el) {
	if(show) {
	    const content = el.querySelector('.alert-content');
	    content.innerHTML += (content.innerHTML ? '<br>' : '') + html;
	    el.classList.remove('d-none');	// Si mise en place PHP
	} else {
	    el.remove();
	}
    } else {
	if(!show) return;
	const main_container = document.getElementById('main-container');
	if(!main_container) throw 'dom_utils.showAlert():ERROR: Veuillez insérer #main-container dans le DOM';
	const color = {success: 'info', error: 'danger'}[type];
	const bi = {success: 'bi-info-circle-fill', error: ' bi-exclamation-triangle-fill'}[type];

	el = createNode(`<div id="alert-${type}" class="alert alert-${color} alert-dismissible fade show" role="alert">
	    <i class="bi ${bi} me-2"></i>
	    <span class="alert-content">${html}</span>
	    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
	</div>`);
	main_container.prepend(el);
    }
    if(show === 'scroll') el.scrollIntoView({block: 'center'});
};

// BOOTSTRAP FORM VALIDATION
// Utilisation common.js pour l'init, ici (pour popup) et à l'ajout html (comme admin_nouveautes.js)
export function addFormValidation(form) {
    if(!form) {
	console.log('dom_utils::addFormValidation():ERROR: veuillez définir le paramètre form');
	return;
    }
    form.addEventListener('submit', e => {
	if(!form.checkValidity()) {
	    e.preventDefault(); e.stopImmediatePropagation();
	}
	form.classList.add('was-validated');
    });
};

// Fade out un element puis le retirer
export async function fadeOutRemove(el, ms = 600) {
    return new Promise((resolve, reject) => {
	el.style.pointerEvents = 'none';
	el.style.transition = 'opacity ' + ms + 'ms ease';
	el.style.opacity = 0;
	setTimeout(() => {
	    el.remove();
	    resolve();
	}, ms);
    });
};

// Récupérer tous les siblings d'un élément
export function getSiblings(el, reverse = false) {
    const siblings = [];
    if(!el.parentNode) return;	    // Inutile de prendre en charge ce cas
    let sibling = el.parentNode.firstChild;
    let position = reverse ? 'after' : 'before';
    while(sibling) {
	if(sibling.nodeType === 1) {
	    if(sibling === el) {
		siblings.push({el: sibling, position: 'current'});
		position = reverse ? 'before' : 'after';
	    } else {
		siblings.push({el: sibling, position});
	    }
	}
	sibling = sibling.nextSibling;
    }
    return reverse ? siblings.reverse() : siblings;
};

// Échanger les positions de 2 siblings dans le DOM
// Les 2 éléments doivent exister (sinon check code)
export function flipSiblings(el1, el2) {
    const tmp_node = el1.parentNode.insertBefore(document.createElement('span'), el1);
    el1.parentNode.insertBefore(el1, el2);
    el1.parentNode.insertBefore(el2, tmp_node);
    tmp_node.remove();
};


// HELPERS locaux
function createNode(html) {
    const template = document.createElement('template');
    template.innerHTML = html;
    var nb_node = template.content.childNodes.length;
    if(nb_node !== 1) throw 'dom_utils.createNode():ERROR: plus de 1 node dans le html: ' + nb_node;
    return template.content.firstChild;
};


